import React from 'react'
import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const Buttons = ({ currentBanner }) => {
  return (
    <>
      {currentBanner.button_text && (
        <Button
          variant={'primary'}
          size={'s'}
          component={'a'}
          href={currentBanner.url}
          target={'_blank'}
        >
          {currentBanner.button_text}
        </Button>
      )}
      {currentBanner.file && (
        <Button
          variant={'ghost'}
          size={'s'}
          component={'a'}
          href={currentBanner.file}
          target={'_blank'}
          noLabel
          startIcon={<Icon name={'download'} />}
        />
      )}
    </>
  )
}

export default Buttons

Buttons.propTypes = {
  currentBanner: PropTypes.object,
}
